import React from 'react';
import { motion } from 'framer-motion';
import { Animations } from '../common/animations/Animations';

const Animated = {
  Component: ({ children, ...props }: any) => {
    return (
      <motion.div variants={Animations.childVariants} {...props} initial='initial' animate='final'>
        {children}
      </motion.div>
    );
  },
  Screen: ({ children, ...props }: any) => {
    return (
      <motion.div variants={Animations.screenVariants} initial='initial' animate='final' {...props}>
        {children}
      </motion.div>
    );
  },
};

export default Animated;
